export default "__VITE_ASSET__BJv5Z2XB__"